import Head from 'next/head'

export function PageHead({
  title = "we're up to good",
  description = 'Doing good is our thing. Our super SIM plans, stonking refurbished phone deals plus Fixed UK prices for 2023 are all good news for your wallet. Find out more',
}: Readonly<{ title?: string; description?: string }>) {
  return (
    <Head>
      <meta content="noindex" name="robots" />
      <meta content="noindex" name="googlebot" />
      <title>{`${title} | giffgaff`}</title>
      <meta content={description} name="description"></meta>
    </Head>
  )
}
